<div class="filters-section">
  <div ds-loading-area-container>
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="brandSelect" class="form-label">Brand</label>
            <ds-select
              id="brandSelect"
              [labellingConfig]="{ placeholder: 'Select a brand' }"
              [options]="brandOptions"
              [(ngModel)]="filters.brand"
              (optionSelected)="onBrandChange($event)"
              required
              [showClearAll]="true"
              class="dropdown_bgcolor"
            ></ds-select>
          </ds-form-field>
        </div>

        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="version1" class="form-label">Version</label>
            <ds-select
              id="version1"
              [labellingConfig]="{ placeholder: 'Select a version' }"
              [options]="filteredVersionOptions"
              [(ngModel)]="filters.version"
              (optionSelected)="onVersionChange($event)"
              [showClearAll]="true"
              class="dropdown_bgcolor"
            ></ds-select>
          </ds-form-field>
        </div>
        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="carInterior" class="form-label"
              >Interior</label
            >
            <ds-select
              id="carInterior"
              [labellingConfig]="{ placeholder: 'Select Interior' }"
              [options]="filteredInteriorOptions"
              [(ngModel)]="filters.interior"
              (optionSelected)="onInteriorChange($event)"
              [showClearAll]="true"
            ></ds-select>
          </ds-form-field>
        </div>

        <div class="col-3">
          <ds-form-field class="w-100">
            <label ds-label for="carOptions" class="form-label">Options</label>
            <ds-select
              id="carOptions"
              [labellingConfig]="{ placeholder: 'Select Options' }"
              [options]="filteredOptions"
              [(ngModel)]="filters.options"
              isMultiselect
              [showClearAll]="true"
            ></ds-select>
          </ds-form-field>
        </div>
      </div>
    </div>
    <br />

    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="storageLocation1" class="form-label"
              >Storage Location</label
            >
            <ds-select
              id="storageLocation1"
              [labellingConfig]="{ placeholder: 'Select Storage Location' }"
              [options]="locationOptions"
              [(ngModel)]="filters.storageLocation"
              [showClearAll]="true"
              class="dropdown_bgcolor"
              (optionSelected)="onStorageLocation($event)"
            ></ds-select>
          </ds-form-field>
        </div>
        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="carModel" class="form-label">Model</label>
            <ds-select
              id="carModel"
              [labellingConfig]="{ placeholder: 'Select a Model' }"
              [options]="filteredModelOptions"
              [(ngModel)]="filters.model"
              (optionSelected)="onModelChange($event)"
              (ngModelChange)="modelSelectedCheck($event)"
              [showClearAll]="true"
              class="dropdown_bgcolor"
            ></ds-select>
          </ds-form-field>
        </div>
        <div class="col-md-3">
          <ds-form-field>
            <label ds-label for="carExterior" class="form-label"
              >Exterior</label
            >
            <ds-select
              id="carExterior"
              [labellingConfig]="{ placeholder: 'Select Exterior' }"
              [options]="filteredExteriorOptions"
              [(ngModel)]="filters.exterior"
              [showClearAll]="true"
              (optionSelected)="onExteriorChange($event)"
            ></ds-select>
          </ds-form-field>
        </div>
        <div class="col-md-3">
          <div
            class="d-flex justify-content-between align-items-end h-100 w-100"
          >
            <ds-form-field class="m-0">
              <ds-checkbox-group>
                <input
                  ds-input
                  type="checkbox"
                  id="bmw"
                  #bmw
                  [checked]="isSearchAllStockChecked"
                  (change)="onCheckboxChange(bmw.checked)"
                />
                <label ds-label for="bmw">Search All DSP Available Stock</label>
              </ds-checkbox-group>
            </ds-form-field>
              @if (showSearch) {
            <ds-button
              ds-loading
              class="btn btn-primary"
              icon="search"
              [disabled]="!isBrandSelected"
              (click)="onSearchClick()"
            >
              Search
            </ds-button>
              }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
